import ScrollReveal from '../../../components/ui/ScrollReveal';

const testimonials = [
  {
    quote:
      'I have been training with Laura for 4 years and it has been an amazing journey. We started training towards the end of 2019, but it was not long before Covid hit. However, we continued to train via video in the following months until we could get back to the gym. So even now we can revert to a video session if I am unable to get in. Today we train at GymBox. Laura normally creates a new programme every couple of months, and we have focused on all parts of the body. I can safely say that my core strength is much better than it has ever been in my life. My overall fitness and body condition is now very good. Laura is very patient but also has the necessary Scottish hard streak to ensure that you do not give up on your exercises and that you continue to improve your personal bests. Give it a go!',
    name: 'Phil',
    result: 'Core strength and overall fitness transformed',
    service: '1-2-1 PT',
  },
  {
    quote:
      "I have had the pleasure of training with Laura Martin since February 2023 and there are not enough adjectives to describe how fantastic she is! Her energy is unmatched and she can even make single leg squats enjoyable. She knows her stuff and is unbelievably talented, and she can point you in the right direction with the things she does not know. That is if she has not gone away to become a master in it! It has been an absolute joy and honour to train with her and I am so grateful to have had the pleasure to meet her! If you need a trainer who will light up even your darkest days, then she is your girl!",
    name: 'Millie',
    result: 'Energy, confidence, and consistency improved',
    service: '1-2-1 PT',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-stone-100 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <ScrollReveal className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-5">
            <span className="w-8 h-px bg-[#c9a96e]" />
            <span className="text-[#c9a96e] text-[10px] font-sans font-semibold tracking-[0.32em] uppercase">Client Stories</span>
            <span className="w-8 h-px bg-[#c9a96e]" />
          </div>
          <h2
            className="text-stone-900"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2.2rem, 4.5vw, 3.6rem)', fontWeight: 600, lineHeight: 1.1 }}
          >
            Real People.{' '}
            <em className="text-[#c9a96e] not-italic">Real Transformations.</em>
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((t, i) => (
            <ScrollReveal key={t.name} delay={i * 90}>
              <div className="bg-white rounded-2xl p-8 flex flex-col h-full shadow-sm border border-stone-200 hover:shadow-md hover:border-[#c9a96e]/20 transition-all duration-300">
                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-[#c9a96e] text-xs" />
                  ))}
                </div>
                <blockquote className="text-stone-600 font-sans text-sm leading-relaxed flex-1 mb-8 italic">
                  "{t.quote}"
                </blockquote>
                <div className="border-t border-stone-100 pt-6">
                  <div className="flex items-center justify-between gap-2 mb-2">
                    <p className="text-stone-900 font-sans font-semibold text-sm">{t.name}</p>
                    <span className="px-2.5 py-1 bg-[#c9a96e]/10 text-[#c9a96e] text-[9px] font-sans font-semibold tracking-widest uppercase rounded-full whitespace-nowrap">
                      {t.service}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#c9a96e]" />
                    <p className="text-[#c9a96e] font-sans text-xs font-medium">{t.result}</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
